import { ShieldX, ArrowLeft, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

export function AccessDenied() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="min-h-dvh flex items-center justify-center bg-background p-4">
      <div className="max-w-md w-full text-center space-y-6">
        {/* Icon */}
        <div className="mx-auto w-20 h-20 rounded-full bg-destructive/10 flex items-center justify-center">
          <ShieldX className="h-10 w-10 text-destructive" />
        </div>

        {/* Title and description */}
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-foreground">
            {t('access_denied')}
          </h1>
          <p className="text-muted-foreground">
            {t('access_denied_description')}
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            {t('go_back')}
          </Button>
          <Button
            onClick={() => navigate('/dashboard')}
            className="gap-2"
          >
            <Home className="h-4 w-4" />
            {t('go_to_dashboard')}
          </Button>
        </div>

        {/* Help text */}
        <p className="text-sm text-muted-foreground pt-4">
          {t('access_denied_help')}
        </p>
      </div>
    </div>
  );
}